<template>
    <div>
        <div id="table_box">
            <p style="font-size: 14px;color: #000000;margin-bottom: 10px;font-weight: 500;width: 70px"><b>投标待办</b></p>
            <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                      style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="100" align="center">
                </el-table-column>
                <el-table-column
                    prop="bidItemName"
                    label="招标项名称"
                >
                </el-table-column>
                <el-table-column
                    prop="projectName"
                    label="项目名称"
                >
                </el-table-column>
                <el-table-column
                    prop="winBidTime"
                    label="接收时间"
                >
                </el-table-column>
                <el-table-column width="200"
                                  label="操作" align="center">
                    <template slot-scope="scope">
                        <!-- flowFormStatus -->
                        <!-- dealSubType -->
                        <span v-if="scope.row.dealSubType == 201">
                            <el-button type="text" @click="replyInvitation(scope.row)">回复邀请函</el-button>
                        </span>
                        <span v-if="scope.row.dealSubType == 213">
                            <el-button type="text" @click="returnBid(scope.row)">立即回标</el-button>
                        </span>
                        <span v-if="scope.row.dealSubType == 206">
                            <el-button type="text" @click="openNegotiation(scope.row)">进入商务谈判</el-button>
                        </span>
                        <span v-if="scope.row.dealSubType == 229">
                            <el-button type="text" @click="showDealNotification(scope.row)">查看中标通知</el-button>
                        </span>
                        <!-- <span v-if="scope.row.dealSubType == 208">
                            <el-button type="text" @click="download(scope.row)">下载标书</el-button>
                        </span> -->

                        <!-- <el-button type="text">查看中标通知</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;padding:10px 0;">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="1"
                    :page-sizes="$root.pageSizesArr"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataCount">
                </el-pagination>
            </div>
        </div>
        <div id="todo-contract">
            <p style="font-size: 14px;color: #000000;margin-bottom: 10px;font-weight: 500;width: 70px"><b>合同待办</b></p>
            <el-table :data="tableData2" :header-cell-style="tableHeaderStyle"
                      style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="100" align="center">
                </el-table-column>
                <el-table-column
                    prop="contactName"
                    label="合同名称">
                </el-table-column>
                <el-table-column
                    prop="contactTypeCode"
                    label="事项类型">
                    <template slot-scope="scope">
                        <label v-if="scope.row.contactTypeCode === 1">验收申请</label>
                        <label v-else-if="scope.row.contactTypeCode === 2">结算申请</label>
                        <label v-else>合同订单</label>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    label="接收时间">
                </el-table-column>
                <el-table-column width="200" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.contactTypeCode === 1 && scope.row.planBalanceAmount!==0" type="text" @click="apply(scope.row)">发起验收申请</el-button>
                        <el-button v-else-if="scope.row.contactTypeCode === 1 && scope.row.planBalanceAmount===0" type="text" @click="check(scope.row)">查看验收申请</el-button>
                        <el-button v-else-if="scope.row.contactTypeCode === 2" type="text" @click="settle(scope.row)">发起结算申请</el-button>
                        <el-button v-else type="text" @click="order(scope.row)">查看合同订单</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;padding: 10px 0">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="1"
                    :page-sizes="$root.pageSizesArr"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataCount2">
                </el-pagination>
            </div>
        </div>
        <div id="todo-contract3" v-if="tableData3 && tableData3.length > 0">
            <el-table :data="tableData3" :header-cell-style="tableHeaderStyle"
                      style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="100" align="center">
                </el-table-column>
                <el-table-column
                    prop="dealTitle"
                    label="待办内容">
                </el-table-column>
                <el-table-column
                    prop="dealDoneTime"
                    label="接收时间">
                </el-table-column>
                <el-table-column width="200"
                                 label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;padding:10px 0;">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="1"
                    :page-sizes="$root.pageSizesArr"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataCount3">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'bidTodoTable',
        data(){
            return {
                form: {
                    pageFlag: 1,
                    pageNumber: 1,
                    pageSize: 10,
                },
                tableData: [],
                tableData2: [],
                tableData3: [],
                dataCount: 0,
                dataCount2: 0,
                dataCount3: 0,

                tableHeaderStyle:{
                    'background-color': '#F6F6F6',
                    'height': '40px',
                    'color': '#333333',
                },
            }
        },
        components: {
        },
        created(){
            this.getData();
        },
        methods:{
            check(val){
                this.$router.push('/contract/check/'+val.id)
            },
            apply(val){
                this.$router.push('/contract/apply/'+val.id)
            },
            order(val){
                this.$router.push('/contract/order/'+val.id)
            },
            settle(val){
                this.$router.push('/settle/add/'+val.id)
            },
            download(row){

            },
            replyInvitation(row){
                this.$router.push('/invitation/'+row.dealId);
            },
            returnBid(row){
                if(row.purchasePlanType == 3 || row.purchasePlanType == 4){
                    this.$router.push({
                        path: '/bidReturnHigher/'+row.dealId,
                        query: {
                            flowFormStatus: row.flowFormStatus
                        }
                    });
                    // this.$router.push('/bidReturnHigher/'+row.dealId);
                }else {
                    this.$router.push('/bidReturnLower/'+row.dealId);
                }
            },
            openNegotiation(row){
                this.$router.push('/businessNegotiation/'+row.dealId);
            },
            showDealNotification(row){
                // this.$router.push('/invitation/'+row.dealId);
                let obj = {
                    dealId: row.dealId,
                    wflowFormId: row.id,
                }
                this.$emit('showWinBid', obj);
            },
            handlePageChange(val){
                let that = this;
                that.form.pageNumber = val;
                that.getData();
            },
            handleSizeChange(val){
                let that = this;
                that.form.pageSize = val;
                that.getData();
            },
            getData(){
                let that = this;
                let params = Object.assign({}, this.form);


                let url = '/v1/outerformflowHS/getMyFormList';

                this.$root.postHttp(url, params, (res) => {
                    that.tableData = res.data.data.list;
                    that.dataCount = res.data.data.count;
                });

                let url2 = '/v1/outerformflowHS/getContractCheckList';

                this.$root.postHttp(url2, params, (res) => {
                    that.tableData2 = res.data.data.list;
                    that.dataCount2 = res.data.data.count;
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import '../assets/_var.scss';
    .search_box{
        text-align: left;
        .el-form-item /deep/{
            width: 300px;
            display: inline-block;
            .el-input__inner{
                border-radius: 0!important;
            }
        }
        .fr{
            float: right;
            color: #333333;
            font-size: 16px;
        }
    }

    #table_box /deep/, #todo-contract /deep/, #todo-contract3 /deep/{
        .table_header th{
            background-color: #F6F6F6!important;
        }

        .el-table th, .el-table td {
            padding: 0px 0;
            font-size: 12px;
        }

        .el-table__body-wrapper {
            font-size: 12px;
        }
        .el-button.el-button--text {
            font-size: 12px;
            padding: 0px;
        }
        .el-table .cell {
            line-height: 32px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/bidTodoTable.vue